export const Tags = ({ items }) => {
  return (
    <ul className="tags">
      {items.map((item) => <li key={item}>{item}</li>)}
    </ul>
  )
}
